<template>
  <CusModal
    @handleCancel="onClose"
    @handleOk="onClickConfirm"
    :title="$t('timeSheets.confirm_submit')"
    :isShow="open"
  >
    <div class="card-modal-infomation">
      <!-- <div class="card-modal-warning">
        Tháng 08/2022 {{ $t("timeSheets.calculate_timesheeet_by_month") }}
      </div> -->
      <div class="title_labour"> Tổng công tiêu chuẩn </div>
      <div class="card-modal-table"> 
        <table>
          <tr>
            <td class="text_color">Công tiêu chuẩn</td>
            <td class="text_color--blue">{{ dayOfWorking }} ngày</td>
          </tr>
          <!-- <tr> -->
            <!-- <td>Công thực tế</td>
            <td class="text_color--red">{{ dayOfWorkingReal }} ngày</td> -->
          <!-- </tr> -->
          <!-- <tr>
                              <td>Nghỉ không lương</td>
                              <td>0.5 ngày</td>
                            </tr>
                            <tr>
                              <td>Công thiếu</td>
                              <td>2.5 ngày</td>
                            </tr>
                            <tr>
                              <td>Phép bù công</td>
                              <td>2.5 ngày</td>
                            </tr>
                            <tr>
                              <td>OT</td>
                              <td>0.5 ngày</td>
                            </tr> -->
        </table>
      </div>
      <div class="title_labour_1">Chi tiết công thức tế</div>
      <div class="card-modal-table">
       <table>
          <tr>
            <td>Công thường</td>
            <td class="text_color--green">{{ normalDayWorking }} ngày</td>
          </tr>
          <tr>
            <td>Công OT</td>
            <td class="text_color--green">{{ overtimeRequestTotal }} ngày</td>
          </tr>
           <tr>
            <td>Ngày nghỉ phép</td>
            <td class="text_color--green">{{ sabbaticalLeave }} ngày</td>
          </tr>
           <tr>
            <td>Ngày nghỉ không lương</td>
            <td class="text_color--green">{{ unpaidLeave }} ngày</td>
          </tr>
          <tr>
            <td>Công bổ sung</td>
            <td class="text_color--green">{{ totalCompensation }} ngày</td>
          </tr>
          <tr>
            <td class="text_color">Tổng công thực tế</td>
            <td class="text_color--red">{{ dayOfWorkingReal }} ngày</td>
          </tr>
          <!-- <tr>
                              <td>Nghỉ không lương</td>
                              <td>0.5 ngày</td>
                            </tr>
                            <tr>
                              <td>Công thiếu</td>
                              <td>2.5 ngày</td>
                            </tr>
                            <tr>
                              <td>Phép bù công</td>
                              <td>2.5 ngày</td>
                            </tr>
                            <tr>
                              <td>OT</td>
                              <td>0.5 ngày</td>
                            </tr> -->
        </table>
        </div>
    </div>
  </CusModal>
</template>

<script>
import CusModal from "@/components/commons/CusModal.vue";

export default {
  props: {
    open: {
      type: Boolean,
      required: true,
    },
    dayOfWorking: {
      type: Number,
      default: 0,
    },
    dayOfWorkingReal: {
      type: Number,
      default: 0,
    },
    normalDayWorking: {
      type: Number,
      default: 0,
    },
     overtimeRequestTotal: {
      type: Number,
      default: 0,
    },
    sabbaticalLeave: {
      type: Number,
      default: 0,
    },
      unpaidLeave: {
      type: Number,
      default: 0,
    },
    totalCompensation: {
      type: Number,
      default: 0,
    }
  },
  components: {
    CusModal,
  },
  methods: {
    onClickConfirm() {
      this.$emit("submitable");
    },
    onClose() {
      this.$emit("close");
    },
  },
};
</script>

<style scoped>
.title_labour{
    text-align: center;
    font-weight: bold;
    font-size: 16px;
    padding: 0 0 5px;
}
.title_labour_1{
    text-align: center;
    font-weight: bold;
    font-size: 16px;
    padding: 15px 0 5px;
}
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.card-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.6);
  z-index: 1030;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.1);
  border-radius: 10px;
}
.card-modal-inner {
  max-width: 700px;
  max-height: 400px;
  margin: 2rem auto;
}

.card-modal-content {
  position: relative;
  background-color: #fff;
  border: 1px solid rgba(0, 0, 0, 0.3);
  background-clip: padding-box;
  border-radius: 10px;
  margin-top: 40%;
}

.card-modal-title {
  border-bottom: 1px solid #3d4cdc;
  padding: 12px;
  display: flex;
  background: #d2d6ff;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
}

.card-modal-label {
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  color: #3d4cdc;
}

.card-modal-button {
  margin-left: auto;
  font-size: 18px;
  font-weight: 800;
  line-height: 18px;
}

.card-modal-action {
  margin: 10px auto 20px;
  width: fit-content;
}

.btn-submit-timesheet {
  width: 200px;
  height: 40px;
  background: #3d4cdc;
  border-radius: 10px;
  color: white;
  border: none;
  font-weight: 700;
  outline: none !important;
}

.btn-cancel-timesheet {
  width: 200px;
  height: 40px;
  background: #ececec;
  border-radius: 10px;
  color: #6f6f6f;
  outline: none !important;
  margin-left: 20px;
  border: none;
  font-weight: 700;
}

/* .card-modal-infomation
{
  padding:12px;
} */
.card-modal-infomation {
  padding-bottom: 10px;
}
.card-modal-warning {
  font-weight: 400;
  font-size: 14px;
  line-height: 16px;
  color: #000000;
  text-align: center;
  margin-top: 10px;
}

.text_color--green {
  color: #17a896;
  font-weight: 700;
}
.text_color--red {
  color: #ff5253;
  font-weight: 700;
}

.text_color--blue {
  color: #3488eb;
  font-weight: 700;
}
.text_color{
 font-weight: bold;
}

.card-modal-dayoff-label {
  font-weight: 400;
  font-size: 14px;
  line-height: 16px;
  color: #000000;
}

.card-modal-select {
  width: 200px;
  display: flex;
  line-height: 14px;
  padding: 5px 0px;
}

.card-modal-option {
  margin-left: 250px;
  margin-top: 20px;
}

.card-modal-select input {
  margin-right: 5px;
  font-size: 14px;
}

.card-modal-button {
  cursor: pointer;
}

.label-dayoff-text {
  margin: 0px 5px;
}

table {
  border-radius: 10px;
}
.card-modal-table {
  border-radius: 10px;
  width: 440px;
  margin: 0 auto;
  border: 1px solid #eaeaea;
}
.card-modal-table table {
  width: 100%;
  border-collapse: collapse;
  /* color: #6f6f6f; */
  /* font-weight: 500; */
}
.card-modal-table table tr td {
  padding: 5px 15px;
  width: 210px;
  font-size: 14px;
}

.card-modal-table table tr td:last-child {
  text-align: end;
}

td:first-child {
  border-right: 1px solid #eaeaea;
}
tr {
  border-bottom: 1px solid #eaeaea;
}
tr:last-child  {
  border-bottom: none;
}

</style>
